import React from 'react';
import PropTypes from 'prop-types';
import Notification from '../notification';
import Spinner from '../spinner';
import EmptyState from '../empty-state';
import { Button } from '~/components/ui/button';

import {
	NotificationList,
	NoNotificationsMsg,
	SpinnerContainer,
	LoadMoreContainer
} from './notifications.css';

function Notifications(props) {
	let {
		notifications,
		hasMore,
		isError,
		isLoadingNew,
		isLoadingMore,
		toNotification,
		onNotificationClick,
		onReadStatusClick,
		onLoadMore
	} = props;

	let isEmptyNotifications = !hasMore && !notifications.length;

	return (
		<NotificationList data-testid="notification-list">
			{isLoadingNew && !isError && (
				<Spinner />
			)}

			{isEmptyNotifications && (
				<NoNotificationsMsg>
					<EmptyState message="No Notifications" />
				</NoNotificationsMsg>
			)}

			{notifications.map((notification) => {
				return (
					<Notification
						key={`item-${notification._id}`}
						notification={notification}
						toNotification={toNotification}
						onNotificationClick={onNotificationClick}
						updateReadStatus={onReadStatusClick}
					/>
				)
				;
			})}

			{hasMore && !isError && isLoadingMore && (
				<SpinnerContainer>
					<Spinner />
				</SpinnerContainer>
			)}

			{hasMore && !isError && !isLoadingMore && (
				<LoadMoreContainer>
					<Button
						variant="secondary"
						onClick={onLoadMore}
					>
						Load More
					</Button>
				</LoadMoreContainer>
			)}
		</NotificationList>
	);
}

Notifications.propTypes = {
	notifications: PropTypes.array.isRequired,
	isError: PropTypes.bool.isRequired,
	hasMore: PropTypes.bool.isRequired,
	isLoadingMore: PropTypes.bool.isRequired,
	isLoadingNew: PropTypes.bool.isRequired,
	toNotification: PropTypes.func.isRequired,
	onNotificationClick: PropTypes.func.isRequired,
	onReadStatusClick: PropTypes.func.isRequired,
	onLoadMore: PropTypes.func.isRequired
};

export default Notifications;
